module.exports = __webpack_public_path__ + "static/img/pc-web-main-01@w.18ad491.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/pc-web-main-01@w.jpg
// module id = eejI
// module chunks = 0